<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general } from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'BeneficiaryDiedYN',
  mixins: [general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Has anyone named in your Will, such as a beneficiary, executor, or trustee, passed away?',
        subTitle: 'The roles you assigned in your Will are critical to ensuring your estate is managed and distributed correctly. If an executor or trustee has passed away, you may need to appoint someone new to handle your affairs. If a beneficiary has died, we need to address what happens to their intended share of your estate to prevent the law from deciding for you.',
        tip: null,
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'beneficiaryDiedYN',
        formPath: 'beneficiaryDiedYN',
        jsonSaveField: 'beneficiaryDiedYN',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
